import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-goals-create-modal',
  templateUrl: './goals-create-modal.component.html',
  styleUrls: ['./goals-create-modal.component.scss']
})
export class GoalsCreateModalComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<GoalsCreateModalComponent>
  ) { }

  ngOnInit(): void {
  }

  onConfirmClick(formValues: any) {
    this.dialogRef.close({
      formValues: formValues});
  }

  onCancelClick() {
    this.dialogRef.close();
  }

}
